import { Box, MenuItem, Select, Typography } from '@material-ui/core'
import { Person, PieChart, TrendingUp } from '@material-ui/icons'
import { colors } from 'theme'
import { Graph } from '@/components/Charts'
import { Content } from '@/components/index'
import { RankingTable } from './rankingTable'
import { AnalysisContainer, StyledCard } from './styles'
import { useInventoryAPILogs } from 'pages/Admin/hooks/useInventoryLogs'

const SEARCH_API_TYPE_OPTIONS = [
  { value: 'complete', label: 'Consulta geral' },
  { value: 'by_product', label: 'Consulta por produto' },
]

const PERIOD_FILTER_OPTIONS = [
  { value: 'lastWeek', label: 'Últimos 7 dias' },
  { value: 'lastMonth', label: 'Últimos 30 dias' },
  { value: 'lastYear', label: 'Último ano' },
]

export const InventoryLogsAnalysis = ({ inventoryLogs }) => {
  const {
    periodFilter,
    setPeriodFilter,
    searchApiType,
    setSearchApiType,
    graphData,
    topProduct,
    topUser,
    totalLogs,
    filteredLogs,
    productCount,
    userCount,
  } = useInventoryAPILogs(inventoryLogs)

  return (
    <Content
      title="Análises"
      Controls={
        <Box style={{ display: 'flex', gap: 12 }}>
          <Select
            value={searchApiType}
            onChange={(e) => setSearchApiType(e.target.value)}
            variant="outlined"
            style={{ color: colors.color600, width: '200px' }}
          >
            {SEARCH_API_TYPE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>

          <Select
            value={periodFilter}
            onChange={(e) => setPeriodFilter(e.target.value)}
            variant="outlined"
            style={{ color: colors.color600, width: '200px' }}
          >
            {PERIOD_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      }
    >
      <Box marginBottom={4}>
        <AnalysisContainer>
          <StyledCard title="Total - Consultas" Icon={TrendingUp}>
            <Typography variant="body2" color="primary">
              {totalLogs}
            </Typography>
          </StyledCard>

          <StyledCard title="Empresa com mais consultas" Icon={Person}>
            <Typography variant="body2" color="primary">
              {topUser.user || '-'}
            </Typography>
          </StyledCard>

          {searchApiType === 'by_product' && (
            <StyledCard title="Produto mais buscado" Icon={PieChart}>
              <Typography variant="body2" color="primary">
                {topProduct.productId || '-'}
              </Typography>
            </StyledCard>
          )}
        </AnalysisContainer>
      </Box>

      <Box>
        <Typography variant="h6" color="primary">
          Consultas por data
        </Typography>
        <Graph
          data={graphData}
          type="Line"
          color={colors.color300}
          decimalCases={0}
        />
      </Box>

      <RankingTable
        inventoryLogs={filteredLogs}
        userCount={userCount}
        productCount={productCount}
        searchApiType={searchApiType}
      />
    </Content>
  )
}
